import React, {FC, useState,useEffect ,MouseEvent}  from 'react';
import { Routes, Route} from 'react-router-dom';

import Loader, { ThreeDots } from "react-loader-spinner";

// import MUI. 
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, MenuItem, IconButton,
  Divider, AppBar, Toolbar} from '@mui/material';
import {NoteAdd as NoteAddIcon, Save as SaveIcon,Menu as MenuIcon, AccountCircle as AccountCircleIcon, 
  ViewList as ViewListIcon, Print as PrintIcon , PictureAsPdf as PictureAsPdfIcon,
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Bolt as BoltIcon,
  MergeType as MergeTypeIcon, Transform as TransformIcon } from '@mui/icons-material';
  
  import Modal from '@mui/material/Modal';
  // import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import {useQuery,useQueryClient, useMutation, useQueries, UseQueryResult } from "react-query";
import { useSnackbar } from 'notistack';
import { useTranslation  } from 'react-i18next';

import useService from '../component/utils/service';

import {IEntityAction,defaultEntityAction, IReportEdition, IPdfFile, ITemplateDocument} from '../component/utils/interface';

// import user Component
import {FormDialog} from '../ui/FormDialog';
import BasicButtonList from '../ui/BasicButtonList';
import ArrayActionParamBox from '../ui/ArrayActionParamBox';

// import user library
import { useUserStore } from '../library/store';
import { globalConfig } from "../configuration/config";
import { routes, AppRoutes } from '../component/Router';


const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


const Master: FC = () => {

  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const {currentUser, isBackendOperation, setIsBackendOperation ,
    getCurrentEntity, getCurrentObjectDataDef, getCurrentObjectKey, getCurrentObjectsKey} = useUserStore();

  const [isNewButtonDisabled, setIsNewButtonDisabled] = useState(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false);
  const [isListButtonDisabled, setIsListButtonDisabled] = useState(false);
  const [isPrintButtonDisabled, setIsPrintButtonDisabled] = useState(false);
  const [isMergeButtonDisabled, setIsMergeButtonDisabled] = useState(false);
  const [isActionButtonDisabled, setIsActionButtonDisabled] = useState(false);

  const [openActionList, setOpenActionList] = useState(false);
  const [openActionParams, setOpenActionParams] = useState(false);
  const [openReportList, setOpenReportList] = useState(false);
  const [openTemplateDocList, setOpenTemplateDocList] = useState(false);
  const [openPdfReport, setOpenPdfReport] = useState(false);
  const [urlPdf, setUrlPdf] = useState('');

  const [entityActions, setEntityActions] = useState<IEntityAction[]>([]);
  const [reportEditions, setReportEditions] = useState<IReportEdition[]>([]);
  const [templateDocs, setTemplateDocs] = useState<ITemplateDocument[]>([]);

  const [displaySpinner, setDisplaySpinner] = useState(false);
    
  const [buttonListType, setButtonListType] = useState('');

  const { getActionsByEntity, executeEntityAction, executeEntitiesAction,
          getReportsByEntity, generateReportAsPdf, generateReportAsPdfEx,
          getTemplateDocsByEntity, mergeDocumentAsPdf,
          getLastErrorMessage
        } = useService();

  const methodsEntityAction = useForm<IEntityAction>( {defaultValues:defaultEntityAction} );
  const { register, setValue ,getValues: getEntityActionValues ,watch, reset: resetEntityAction ,control , formState: { errors } } = methodsEntityAction;
  let {fields: actionParams} = useFieldArray<IEntityAction,'params'>({
    control, 
    name: 'params'});

  const {isLoading: isEntityLoading, isError, isSuccess ,error,mutate: mutateEntity } = useMutation<any,Error,IEntityAction>(executeEntityAction, {        
      onSuccess: (data: any) => {
        enqueueSnackbar( t('_Operation_done'), { variant: 'success',
              anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 });  
      
      const btn = document.getElementById(`btnAfterAction`);
      if(btn == null) {
        // enqueueSnackbar( 'bad action ...', { variant: 'error',
        //   anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
        return;
      }     
      btn?.click();     
     
      },
      onError: (err: Error) => {
        enqueueSnackbar( error?.message, { variant: 'error',
              anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
      }
    }); 

  const {isLoading: isEntitiesLoading, mutate: mutateEntities } = useMutation<any,Error,IEntityAction[]>(executeEntitiesAction, {        
    onSuccess: (data: any) => {
      enqueueSnackbar( t('_Operation_done'), { variant: 'success',
            anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 });   
    },
    onError: (err: Error) => {
      enqueueSnackbar( error?.message, { variant: 'error',
            anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
    }
  }); 

  useEffect( () => {
    setIsBackendOperation(isEntityLoading);
  }, [isEntityLoading]);


  useEffect( () => {

    const btnSave = document.getElementById(`btnSave`);
    setIsSaveButtonDisabled( btnSave === null);

    const btnNew = document.getElementById(`btnNew`);
    setIsNewButtonDisabled( btnNew === null);

    const btnList = document.getElementById(`btnList`);
    setIsListButtonDisabled( btnList === null);    

    setIsPrintButtonDisabled( getCurrentObjectDataDef() === '' || getCurrentObjectKey() === '');

    setIsMergeButtonDisabled( getCurrentObjectDataDef() === '' || getCurrentObjectKey() === '');

    setIsActionButtonDisabled( getCurrentObjectDataDef() === '' || getCurrentObjectKey() === '');

  }, [getCurrentObjectDataDef(),getCurrentObjectKey()])

  const handleNewClick = async (event : MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const btn = document.getElementById(`btnNew`);
    if(btn == null) {
      enqueueSnackbar( 'bad action ...', { variant: 'error',
        anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
      return;
    }

    setDisplaySpinner(true);    
    await btn?.click();     
    setDisplaySpinner(false);    
  }

  const handleSaveClick = async (event : MouseEvent<HTMLButtonElement>) => {
    //const btn = document.getElementById(`btnSave${getCurrentEntity()}`);
    event.preventDefault();
    const btn = document.getElementById(`btnSave`);
    if(btn == null) {
      enqueueSnackbar( 'bad action ...', { variant: 'error',
        anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
      return;
    }

    setDisplaySpinner(true);    
    await btn?.click();     
    setDisplaySpinner(false);    
  }

  const handleListClick = (event : any) => {
    const btn = document.getElementById(`btnList`);
    // if(btn == null)
    //   alert('bad action');

    btn?.click();  
  }

  const handlePrintClick = async (event : any) => {
    const currentObjectDataDef = getCurrentObjectDataDef();
    const currentObjectKey = getCurrentObjectKey();
    
    const reports = await getReportsByEntity(currentObjectDataDef, currentObjectKey);
    setReportEditions(reports);    
    setOpenReportList(true);
  }

  const handleMergeClick = async (event : any) => {
    const currentObjectDataDef = getCurrentObjectDataDef();
    const currentObjectKey = getCurrentObjectKey();
    
    const docs = await getTemplateDocsByEntity(currentObjectDataDef,currentObjectKey);
    setTemplateDocs(docs);
    setOpenTemplateDocList(true);    
  }

  const handleActionClick = async (event : any) => {
    const currentObjectDataDef = getCurrentObjectDataDef();
        
    const actions = await getActionsByEntity(currentObjectDataDef);
    setEntityActions(actions);
    setOpenActionList(true);
  }

  const handleEntityActionClick = (actionSelected: IEntityAction) => {
    const currentObjectDataDef = getCurrentObjectDataDef();    
    const currentObjectKey = getCurrentObjectKey();

    const currentObjectsKey = getCurrentObjectsKey();  

    console.log(actionSelected); 
    
    if(actionSelected.params.length === 0) {
      if( currentObjectKey !== '@UnivList@' && currentObjectKey !== '') 
        mutateEntity( {...actionSelected, objectDataDef:currentObjectDataDef, objectKey: currentObjectKey  } ); 
      else if(currentObjectKey === '@UnivList@') 
        mutateEntities( currentObjectsKey.map( (objKey,idx) => ({...actionSelected,objectDataDef:currentObjectDataDef, objectKey: objKey}) ) );      
    } else {
      resetEntityAction({name:actionSelected.name ,objectDataDef: currentObjectDataDef, objectKey: currentObjectKey, params:actionSelected.params });
      setOpenActionParams(true);
    }
    
    setOpenActionList(false);
  }
  
  const handleOkActionParams = () => {
    const currentObjectDataDef = getCurrentObjectDataDef();    
    const currentObjectKey = getCurrentObjectKey();
    const currentObjectsKey = getCurrentObjectsKey();

    setOpenActionParams(false);
        
    const actionSelected = getEntityActionValues(); 
    if( currentObjectKey !== '@UnivList@' && currentObjectKey !== '')
      mutateEntity( {...actionSelected, objectDataDef:currentObjectDataDef, objectKey: currentObjectKey  } ); 
    else
      mutateEntities( currentObjectsKey.map( (objKey,idx) => ({...actionSelected,objectDataDef:currentObjectDataDef, objectKey: objKey}) ) ); 
  }

  const handleReportEditionClick = async (reportEdition: IReportEdition) => {
    const currentObjectDataDef = getCurrentObjectDataDef();
    const currentObjectKey = getCurrentObjectKey();

    const {reportLayoutID, objectEditionID, editionType, routine } = reportEdition;

    let urlReportPdf = '';
    //console.log({...reportEdition, currentObjectDataDef, currentObjectKey});
    if( (editionType || '') == 'Object_Edition' ) {
      const {urlPdf} = await generateReportAsPdf(currentObjectDataDef, currentObjectKey, objectEditionID, reportLayoutID, 'fr-FR' ) as IPdfFile;
      setUrlPdf(urlPdf);
    } else if( (editionType || '') !== '' ) {
      const {urlPdf} = await generateReportAsPdfEx(currentObjectDataDef, currentObjectKey, routine || '', reportLayoutID, 'fr-FR' ) as IPdfFile;
      setUrlPdf(urlPdf);
    } 
   

    setOpenPdfReport(true);
    //alert(report);
    //setOpenReportList(false);
    //mutate( {...actionSelected, objectDataDef:currentObjectDataDef, objectKey: currentObjectKey  } )
  }

  const handleTemplateDocumentClick = async (templateDocument: ITemplateDocument) => {
    const currentObjectDataDef = getCurrentObjectDataDef();
    const currentObjectKey = getCurrentObjectKey();

    const {documentCode} = templateDocument;    
    
    try {
      const res = await mergeDocumentAsPdf(currentObjectDataDef, currentObjectKey, documentCode, 'fr-FR' ) as IPdfFile;
      console.log(res);
      const {urlPdf} = res;
      setUrlPdf(urlPdf);
      setOpenPdfReport(true);
    } catch(error) {
      const lastError = await getLastErrorMessage();
          enqueueSnackbar( lastError , { variant: 'error',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });  
    } 
    //mutate( {...actionSelected, objectDataDef:currentObjectDataDef, objectKey: currentObjectKey  } )
  }

    return (
      <>
        <Grid container component="main" sx={{ height: 'calc(100vh) - 64px' }}>
          <Grid item container xs={12} alignContent="center" alignItems="center">
            {/* <AppBar position="static" sx={{ height: '32px', minHeight: '32px', justifyContent : 'center' }}>
              <Toolbar variant="dense"> */}
                <IconButton edge="start" color="primary" aria-label="menu" sx={{ mr: 2 }}>
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" color="secondary" component="span">
                  {getCurrentEntity()}
                </Typography>
                <Box sx={{ flexGrow: 0.25 }} />
                { isBackendOperation && <ThreeDots color='#00BFFF' height={'100%'} /> }
              {/* </Toolbar>
            </AppBar> */}
            <Box sx={{ flexGrow: 0.25 }} />
            <IconButton aria-label="account of current user" aria-controls="menu-account" aria-haspopup="true" color="primary" 
              onClick={handleNewClick} disabled={isNewButtonDisabled} >
              <NoteAddIcon />
            </IconButton>
            <IconButton aria-label="account of current user" aria-controls="menu-account" aria-haspopup="true" color="primary" 
              onClick={handleSaveClick} disabled={isSaveButtonDisabled}>
              <SaveIcon />
            </IconButton>
            
          <IconButton aria-label="account of current user" aria-controls="menu-account" aria-haspopup="true" color="primary" 
              onClick={handleListClick} disabled={isListButtonDisabled}>
              <ViewListIcon />
          </IconButton>
          <IconButton aria-label="account of current user" aria-controls="menu-account" aria-haspopup="true" color="primary" 
              onClick={handlePrintClick} disabled={isPrintButtonDisabled}>
              <PrintIcon />
          </IconButton>
          <IconButton aria-label="account of current user" aria-controls="menu-account" aria-haspopup="true" color="primary" 
              onClick={handleMergeClick} disabled={isMergeButtonDisabled}>
              <MergeTypeIcon />
          </IconButton>
          <IconButton aria-label="account of current user" aria-controls="menu-account" aria-haspopup="true" color="primary" 
              onClick={handleActionClick} disabled={isActionButtonDisabled} >
              <TransformIcon />              
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          </Grid>
          <Divider />
          { openActionList && <FormDialog open={openActionList} maxWidth='xs'
              okText='' cancelText='' title={t('Select Action')} onCancel={()=> {setOpenActionList(false);}} 
              onClose={()=> {setOpenActionList(false);}} onOk={()=> {setOpenActionList(false);}}  >
              <Box sx={{ mt: 1, width: '100%' }} >
                {entityActions && <BasicButtonList<IEntityAction>  icon={BoltIcon}
                  items={entityActions} onItemClick={handleEntityActionClick}
                  valueKey={'name'} displayKey={'caption'} title={t('Actions')} /> }
              </Box>
            </FormDialog> }
            { openActionParams && <FormDialog open={openActionParams} maxWidth='xs'
              okText='Ok' cancelText='Cancel' title={t('Parameters')} onCancel={()=> {setOpenActionParams(false);}} 
              onClose={()=> {setOpenActionParams(false);}} onOk={handleOkActionParams}  >
              <Box sx={{ mt: 1, width: '100%' }} >
                <FormProvider {...methodsEntityAction} >
                {actionParams && <ArrayActionParamBox fields={actionParams} fieldsName='params' fieldsPerRow={1} /> }
                </FormProvider>
              </Box>
            </FormDialog> } 
          { openReportList && <FormDialog open={openReportList} maxWidth='xs'
            okText='' cancelText='' title={t('Select Report')} onCancel={()=> {setOpenReportList(false);}} 
            onClose={()=> {setOpenReportList(false);}} onOk={()=> {setOpenReportList(false);}}  >
            <Box sx={{ mt: 1, width: '100%' }} >
              {reportEditions && <BasicButtonList<IReportEdition>  
                items={reportEditions} onItemClick={handleReportEditionClick} icon={PictureAsPdfIcon}
                valueKey={'reportLayoutID'} displayKey={'reportLayoutName'} title={t('Reports')} /> }
            </Box>
          </FormDialog> }
          { openTemplateDocList && <FormDialog open={openTemplateDocList} maxWidth='xs'
            okText='' cancelText='' title={t('Select Report')} onCancel={()=> {setOpenTemplateDocList(false);}} 
            onClose={()=> {setOpenTemplateDocList(false);}} onOk={()=> {setOpenTemplateDocList(false);}}  >
            <Box sx={{ mt: 1, width: '100%' }} >
              
                {templateDocs && <BasicButtonList<ITemplateDocument>  
                  items={templateDocs} onItemClick={handleTemplateDocumentClick} icon={PictureAsPdfIcon}
                  valueKey={'documentCode'} displayKey={'docReference'} title={t('Templ. Docs')} /> }
              
            </Box>
          </FormDialog> }
          { openPdfReport && <FormDialog open={openPdfReport} maxWidth='md'
            okText='' cancelText='' title={t('Printing')} onCancel={()=> {setOpenPdfReport(false);}} 
            onClose={()=> {setOpenPdfReport(false);}} onOk={()=> {setOpenPdfReport(false);}}  >
            <Box sx={{ mt: 1, width: '100%', height: '100%' }} >
              <iframe src={`${globalConfig.get().apiUrl}/${urlPdf}`} width="100%" height="100%" title='kkk'></iframe>
            </Box>
          </FormDialog> }
          <Grid item xs={12} component={Paper} square>           
              
                < AppRoutes/>
            
          </Grid>         
        </Grid>
      </>
    );
  }
  
  export default Master;